const comments = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20smiling%20warmly%2C%20clean%20light%20background%2C%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20simple%20composition&width=80&height=80&seq=avatar-pipi-01&orientation=squarish',
    text: '真的是我用过最好用的免费追剧网站！资源超全，更新也快，画质清晰不卡顿。狂飙就是在屁屁影院追完的，强推！',
    time: '3天前',
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20clean%20minimal%20background%2C%20warm%20soft%20lighting%2C%20natural%20looking%20photography&width=80&height=80&seq=avatar-pipi-02&orientation=squarish',
    text: '港剧经典系列太全了！陀枪师姐、刑事侦缉档案全都有高清修复版，重温童年的回忆，感动到哭。不用注册真的太方便了。',
    time: '5天前',
  },
  {
    name: '深夜追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2020s%20with%20calm%20expression%2C%20simple%20studio%20lighting%2C%20clean%20neutral%20background%2C%20modern%20casual%20style&width=80&height=80&seq=avatar-pipi-03&orientation=squarish',
    text: '每天晚上睡前必须刷两集长风渡，播放流畅不缓冲，手机看也很清楚。希望一直保持这个质量，会一直支持下去的！',
    time: '1周前',
  },
  {
    name: '韩剧十级学者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20bright%20smile%2C%20clean%20light%20background%2C%20soft%20diffused%20lighting%2C%20warm%20and%20friendly%20look&width=80&height=80&seq=avatar-pipi-04&orientation=squarish',
    text: '韩剧更新速度太惊喜了！热门韩剧基本同步韩国播出，中文字幕也很及时。终于不用到处找片源了，一个屁屁影院全部搞定。',
    time: '1周前',
  },
  {
    name: '周末影迷老张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Chinese%20man%20with%20warm%20genuine%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20friendly%20and%20approachable%20look&width=80&height=80&seq=avatar-pipi-05&orientation=squarish',
    text: '周末和老婆一起在屁屁影院看电影，高清流畅真的爽。纪录片频道也很惊喜，地球脉动4K版太震撼了。推荐给了好多朋友。',
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听追剧伙伴们怎么说，好口碑来自真实体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <h3 className="text-sm font-bold text-foreground-900 whitespace-nowrap">{comment.name}</h3>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-1 mt-3 text-accent-500 text-xs">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}